<template>
  <div class="userincontainer">
    <md-dialog
      title="用戶昵稱"
      :closable="true"
      v-model="basicDialog.open"
      :btns="basicDialog.btns"
    >
      <md-input-item
        v-model="username"
        placeholder="請輸入用戶昵稱"
      ></md-input-item>
    </md-dialog>

    <md-dialog
      title="绑定郵箱"
      :closable="true"
      v-model="emailDialog.open"
      :btns="emailDialog.btns"
    >
      <md-input-item
        ref="input0"
        v-model="form.email"
        placeholder="請輸入郵箱"
        @blur="checkEmail"
      >
        <img
          src="@/assets/image/icon_email.png"
          alt=""
          bslot="left"
          class="logo"
        />
        <p v-if="errorTip.email" class="error" slot="error">
          請輸入正確的郵箱地址
        </p></md-input-item
      >
      <md-input-item
        v-model="form.code"
        placeholder="請輸入郵箱驗證碼"
        :maxlength="6"
        type="digit"
        @blur="checkBankcode"
      >
        <div class="codecontaine" slot="right">
          <span @click="send" style="color: #097ef7">{{ time }}</span>
        </div>
        <p v-if="errorTip.code" class="error" slot="error">
          請輸入正確的郵箱驗證碼
        </p></md-input-item
      >
      <md-input-item
        v-model="form.passWord"
        placeholder="請輸入密碼"
        :maxlength="20"
        :type="showpass ? 'password' : 'text'"
        @blur="checkBankpassWord"
      >
        <md-icon
          :name="showpass ? 'invisible' : 'visible'"
          size="lg"
          slot="right"
          @click="showpass = !showpass"
        ></md-icon>
        <p v-if="errorTip.passWord" class="error" slot="error">
          請輸入6~20比特非純數位密碼
        </p></md-input-item
      >
      <p style="margin-top: 0.6rem">
        綁定後, 郵箱不可修改
      </p>
      <p>
        您下次可使用該郵箱作為賬號登錄
      </p>
    </md-dialog>
    <md-dialog
      title="绑定手机"
      :closable="true"
      v-model="phonelDialog.open"
      :btns="phonelDialog.btns"
    >
      <md-input-item
        ref="input0"
        v-model="phone"

        placeholder="請輸入手机"
      >
        <img
          src="@/assets/image/icon_email.png"
          alt=""
          bslot="left"
          class="logo"
        />
        <div class="codecontaine" slot="left">
          <md-field-item :addon="'+'+phonecode"
                         @click="isPickerShowphonecode = true">
          </md-field-item>
          <div class="listcontainer" v-if="isPickerShowphonecode">
            <div v-for="(item,index ) in phoneList" :key="index" @click="onPhone(item.code)">
              <span>{{ item.code }}</span>
            </div>
          </div>
        </div>
      </md-input-item
      >
      <md-input-item
        v-if="phonecode!='86'"
        v-model="code"
        placeholder="請輸入手机驗證碼"
        :maxlength="6"
        type="digit"
        @blur="checkBankcode"
      >
        <div class="codecontaine" slot="right">
          <span @click="sendmobile" style="color: #097ef7">{{ time }}</span>
        </div>
      </md-input-item>
      <p style="margin-top: 0.6rem">
        綁定後, 手机号不可修改
      </p>
    </md-dialog>

    <md-field>
      <md-field-item
        solid
        title="郵箱"
        :addon="userinfo.email"
        :arrow="isBlank(userinfo.email)"
        @click="openModal"
      />
      <md-field-item
        solid
        title="用戶昵稱"
        :addon="userinfo.accountName"
        arrow
        @click="basicDialog.open = true"
      />
      <md-field-item
        solid
        title="手机号"
        addon="未绑定"
        arrow
        @click="phonelDialog.open = true"
        v-if="!userinfo.mobile"
      />
      <md-field-item
        solid
        title="手机号"
        :addon="'+'+userinfo.mobileCode+'-'+userinfo.mobile"
        v-if="userinfo.mobile"
      />
      <md-field-item
        solid
        title="修改密碼"
        arrow
        @click="$router.push({ name: 'RepertPassward' })"
        no-border
      />
    </md-field>
  </div>
</template>

<script>
import {
  Dialog,
  Field,
  FieldItem,
  Button,
  InputItem,
  DropMenu,
  Toast, Selector
} from "mand-mobile";
import {isBlank} from "@/until/common.js";
import md5 from "js-md5";

export default {
  name: "useRepert",
  components: {
    [Dialog.name]: Dialog,
    [Field.name]: Field,
    [DropMenu.name]: DropMenu,
    [Button.name]: Button,
    [FieldItem.name]: FieldItem,
    [InputItem.name]: InputItem,
    [Selector.name]: Selector,
  },
  data() {
    return {
      userinfo: {
        email: "",
        accountName: ""
      },
      code: '',
      phonecode: '',
      phone: '',
      // 修改昵称
      username: "",
      basicDialog: {
        open: false,
        btns: [
          {
            text: "取消"
          },
          {
            text: "確定",
            handler: this.onBasicConfirm
          }
        ]
      },
      phonelDialog: {
        open: false,
        btns: [
          {
            text: "取消"
          },
          {
            text: "確定",
            handler: this.phoneConfirm
          }
        ]
      },
      isPickerShowphonecode: false,
      // 绑定邮箱
      form: {
        code: "",
        email: "",
        passWord: ""
      },
      showpass: true,
      emailDialog: {
        open: false,
        btns: [
          {
            text: "取消"
          },
          {
            text: "確定",
            handler: this.onBasicConfirmChangeEmail
          }
        ]
      },
      errorTip: {
        email: false,
        code: false,
        passWord: false
      },
      phoneList: [],
      time: "獲取驗證碼",
      currentTime: 60,
      disabled: true // 邮箱防重复点击
    };
  },
  activated() {
    this.getMobileCode();
    this.userinfo = JSON.parse(localStorage.getItem("userinfoMobie"));
  },
  methods: {
    isBlank,
    logout() {
      this.http.APIASK(this.ports.loginOut, "post").then(res => {
        localStorage.removeItem("userinfoMobie");
        localStorage.removeItem("mupressMobiltoken");
        localStorage.removeItem("headerParams");
        this.$router.go(-1);
      });
    },
    onPhone(text) {

      this.phonecode = text;
      this.isPickerShowphonecode = false
    },
    // 修改昵称
    onBasicConfirm() {
      if (this.username) {
        const par = {
          accountName: this.username
        };
        this.http
          .APIASK(this.ports.userupdate, "post", par)
          .then(res => {
            Toast.succeed("修改成功");
            this.getUserInfo();
          })
          .catch(err => {
          });
      } else {
        Toast.failed("請輸入用戶昵稱");
      }
    },
    getUserInfo() {
      this.http
        .APIASK(this.ports.getUserInfo, "get")
        .then(res => {
          localStorage.setItem("userinfoMobie", JSON.stringify(res));
          this.userinfo = JSON.parse(localStorage.getItem("userinfoMobie"));
          this.basicDialog.open = false;
          this.emailDialog.open = false;
        })
        .catch(err => {
        });
    },
    getMobileCode() {
      this.http.APIASK(this.ports.getMobileCode, 'POST', {}).then((res) => {
        console.log('res', res)
        for (let i in res) {
          res[i].text = res[i].code;
          res[i].label = res[i].code;
          res[i].value = res[i].code;
        }
        this.phonecode = res[0].text
        this.phoneList = res
        // this.countryList = res;
      });
    },
    // 修改邮箱
    openModal() {
      if (!isBlank(this.userinfo.email)) {
        return false;
      }
      this.form = {
        code: "",
        email: "",
        passWord: ""
      };
      this.errorTip = {
        email: false,
        code: false,
        passWord: false
      };
      this.time = "獲取驗證碼";
      this.currentTime = 60;
      this.disabled = true;
      this.showpass = true;
      this.emailDialog.open = true;
    },
    isclick() {
      if (
        this.errorTip.email === true &&
        this.errorTip.code === true &&
        this.errorTip.passWord === true
      ) {
        return false;
      } else {
        return true;
      }
    },
    phoneConfirm() {
      if (!this.phone) {
        Toast({content: '請輸入手机号', duration: 3000});
        return
      }
      if (this.phonecode === '86') {
        var reg = /^1[3456789]\d{9}$/;
        if (!reg.test(this.phone)) {
          Toast.failed('请输入正确的手机号');
          return;
        }
      }
      if (this.phonecode != '86') {
        if (!this.code) {
          Toast.failed('请输入手机验证码');
          return;
        }
      }
      const par = {
        "code": this.code,
        "phone": this.phone,
        "phoneCode": this.phonecode,
        "shopCode": localStorage.getItem("shopkey") ? JSON.parse(localStorage.getItem("shopkey")).appCode : undefined
      }
      this.http
        .APIASK(this.ports.bindingMobile, "post", par)
        .then(res => {
          this.phonelDialog.open = false
          Toast.succeed('手机号绑定成功')
          this.getUserInfo();
        })

    },
    checkEmail() {
      var reg = new RegExp(
        "^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*\$"
      );
      if (!reg.test(this.form.email)) {
        this.errorTip.email = true;
      } else {
        this.errorTip.email = false;
      }
    },
    checkBankpassWord() {
      if (this.isNumberOr_Letter(this.form.passWord)) {
        this.errorTip.passWord = false;
      } else {
        this.errorTip.passWord = true;
      }
    },
    isNumberOr_Letter(s) {
      var regu = "^(?=.*\\d)(?=.*[a-z])[a-zA-Z\\d]{6,20}$";
      var re = new RegExp(regu);
      if (re.test(s)) {
        return true;
      } else {
        return false;
      }
    },
    checkBankcode() {
      if (this.form.code && this.form.code.length == 6) {
        this.errorTip.code = false;
      } else {
        this.errorTip.code = true;
      }
    },
    // 邮箱验证码
    send() {
      const _this = this;

      if (_this.form.email && _this.errorTip.email === true) {
        Toast({content: "請輸入正確的郵箱地址", duration: 3000});
        return false;
      }

      if (_this.form.email && _this.disabled) {
        const par = {
          email: _this.form.email
        };
        if (localStorage.getItem("shopkey")) {
          par.appCode = JSON.parse(localStorage.getItem("shopkey")).appCode;
        }

        if (isBlank(par.appCode)) {
          this.$router.replace({
            name: "Home"
          });
        }

        this.http
          .APIASK(this.ports.sendEmailCode, "post", par)
          .then(res => {
            let interval = null;
            let currentTime = _this.currentTime;
            Toast({content: "驗證碼已發送", duration: 3000});
            interval = setInterval(function () {
              currentTime--;
              _this.time = currentTime + "S";
              if (currentTime <= 0) {
                clearInterval(interval);
                _this.time = "獲取驗證碼";
                _this.currentTime = 60;
                _this.disabled = true;
              }
            }, 1000);
            _this.disabled = false;
          })
          .catch(err => {
            _this.time = "獲取驗證碼";
            _this.currentTime = 60;
            _this.disabled = true;
          });
      } else if (!_this.form.email && _this.disabled) {
        Toast({content: "請輸入emai地址", duration: 3000});
      } else if (_this.form.email && !_this.disabled) {
        Toast({content: "驗證碼已發送", duration: 3000});
        return false;
      }
    },
    sendmobile() {
      if (!this.phone) {
        Toast({content: '請輸入手机号', duration: 3000});
        return
      }
      const _this = this;
      if (_this.phone && _this.disabled) {
        const par = {
          "phone": _this.phone,
          "phoneCode": _this.phonecode,
          "shopCode": localStorage.getItem("shopkey") ? JSON.parse(localStorage.getItem("shopkey")).appCode : undefined,
        };
        this.http
          .APIASK(this.ports.sendMobileCode, 'post', par)
          .then((res) => {
            Toast.succeed('手机验证码已发送至您的手机')

            let interval = null;
            let currentTime = _this.currentTime;
            interval = setInterval(function () {
              currentTime--;
              _this.time = currentTime + 'S';
              if (currentTime <= 0) {
                clearInterval(interval);
                _this.time = '获取手机验证码'
                _this.currentTime = 60;
                _this.disabled = true;
              }
            }, 1000);
            _this.iconDialog.open = true;
            _this.disabled = false;
          })
          .catch((err) => {
            if (err.code == 406) {
              _this.$emit('islogin');
            }
            _this.time = '获取手机验证码',
              (_this.currentTime = 60),
              (_this.disabled = true);
          });
      } else if (!_this.email && _this.disabled) {
        Toast({content: '請輸入手机号', duration: 3000});
      } else if (_this.email && !_this.disabled) {
        Toast({content: '驗證碼已發送', duration: 3000});
        return false;
      }
    },
    onBasicConfirmChangeEmail(btn) {
      if (
        isBlank(this.form.email) ||
        isBlank(this.form.code) ||
        isBlank(this.form.passWord)
      ) {
        this.checkEmail();
        this.checkBankpassWord();
        this.checkBankcode();
        return false;
      }
      if (
        this.errorTip.email === true ||
        this.errorTip.code === true ||
        this.errorTip.passWord === true
      ) {
        this.checkEmail();
        this.checkBankpassWord();
        this.checkBankcode();
        return false;
      }

      this.$set(btn, "loading", true);
      this.$set(btn, "text", "绑定中");
      let param = JSON.parse(JSON.stringify(this.form));
      param.passWord = md5(param.passWord);
      this.http
        .APIASK(this.ports.bindEmail, "post", param)
        .then(res => {
          Toast.succeed("绑定成功");
          this.$set(btn, "loading", false);
          this.$set(btn, "text", "确定");
          this.getUserInfo();
        })
        .catch(err => {
          this.$set(btn, "loading", false);
          this.$set(btn, "text", "确定");
        });
    }
  }
};
</script>

<style lang="less">
.userincontainer {
  .md-field {
    padding: 0 0.4rem;
  }

  .md-field-item-content:before {
    content: "";
    position: absolute;
    z-index: 2;
    -webkit-transform: scaleY(0.5) translateY(100%);
    transform: scaleY(0.5) translateY(100%);
    bottom: 0;
    left: 0;
    right: auto;
    top: auto;
    width: 100%;
    border-bottom: 0.02rem solid #e2e4ea;
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
  }

  .md-field-item-title {
    text-align: left;
  }
}

.codecontaine .md-field-item-content {
  position: relative;
  width: 1rem;
}

.codecontaine .md-field-item-content::after {
  content: '';
  width: 0.18rem;
  height: 0.18rem;
  border-bottom: 0.025rem solid #858b9c;
  border-right: 0.025rem solid #858b9c;
  position: absolute;
  left: 0.85rem;
  top: 0.34rem;
  transform: rotate(45deg);

}

.codecontaine .md-field-item-content .md-field-item-right {
  position: absolute;
  left: 0;
}
//1
.listcontainer {
  border: 1px solid #f2f2ff;
  width: 1.5rem;
  max-height: 3rem;
  overflow-y: scroll;
  position: absolute;
  bottom: -1rem;
  background-color: white;
  z-index: 9999;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}

.listcontainer div {
  height: 0.6rem;
  border-bottom: 1px solid #f2f2ff;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
